import PlayerSowStore from "@state/stores/sow/PlayerSowStore";
import { createContext } from "react";

export const PlayerSowStoreContext = createContext<PlayerSowStore | null>(null);
